import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HelpDocsService } from '@mode/shared/util-js';
import { AnalyticsEvent } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-link-tab',
  templateUrl: './link-tab.component.html',
  styleUrls: ['./link-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkTabComponent {
  @Input() internalLiveReportLink = '';
  @Input() internalStaticReportLink = '';
  @Input() externalLiveReportLink = '';
  @Input() externalStaticReportLink = '';
  @Input() reportShared = false;

  constructor(public helpDocs: HelpDocsService) {}

  public readonly mostRecentRunMessage = 'This link always shows data from the most recent successful Report run';
  public readonly staticRunMessage = 'This link shows data for the Report run being viewed right now';

  public readonly internalLiveReportEventPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.CopyIntSharingRecentClicked,
  };
  public readonly internalStaticEventPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.CopyIntSharingStaticClicked,
  };
  public readonly externalLiveReportLinkEventPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.CopyExtSharingRecentClicked,
  };
  public readonly externalStaticReportEventPayload = {
    location: AnalyticsEvent.SubContext.ShareReport,
    action: AnalyticsEvent.Name.CopyExtSharingStaticClicked,
  };
}
